import { dcolors } from "corexxx";
import { OnePager } from "../../libs/components/simpleonepager/OnePager";
import { PageHeaderMenu } from "../../libs/dweb/DPageHeaderMenu";
import { DResponsiveWindow } from "../../libs/dweb/DResponsiveWindow";
import { CSSProperties } from "react";

function CommonHeader({ style }: { style?: CSSProperties }) {
  return (
    <PageHeaderMenu
      logo={require("../asserts/img/logo.png")}
      rightDropDownActions={[{ text: "dashboard", href: "/dashboard" }]}
      leftNavigationList={[
        { text: "dashboard", href: "/dashboard" },
        {
          text: "Free Tools",
          href: "/dashboard",
          children: [
            {
              text: "Mortgage Planner",
              href: "/free_tool/mc",
            },
            {
              text: "Year of Budgets",
              href: "/free_tool/yb",
            },
            {
              text: "Opertunities",
              href: "/free_tool/op",
            },
            {
              text: "Growth Analysis",
              href: "/free_tool/growth",
            },
          ],
        },
      ]}
      style={{ backgroundColor: "#0000ff00", ...style }}
    />
  );
}

export function LandingPageBase({ children }: { children: any }) {
  return (
    <div>
      <CommonHeader style={{ backgroundColor: "black" }} />
      <div style={{ marginTop: 60 }}>{children}</div>
    </div>
  );
}

export function LandingPage() {
  return (
    <OnePager
      extraElement={<CommonHeader />}
      config={{
        theme: {
          backgroundColor: dcolors.pallets.red800,
        },
        hero_section: {
          hero_title:
            "Experience Smarter Financial Management with Grodok Money—Track, Plan, and Grow Your Wealth Effortlessly.",
          hero_subtitle:
            "Grodok Money helps you consolidate all your assets and liabilities to gain a complete financial overview, assess your financial health, and project your future growth.",
          hero_image_src: "",
          primary_btn_link: "/dashboard",
          primary_btn_subtext:
            "Join for free—no credit card required. Start managing your finances!",
          primary_btn_title: "Join us today",
        },
        generic_section: [
          {
            groupOfThree: [
              {
                title: "Track All Your Bank Accounts",
                subtitle:
                  "Effortlessly monitor all your bank accounts in one place for a clear and comprehensive financial view.",
                btn_text: "Track your accounts",
                btn_link: "/dashboard",
              },
              {
                title: "Plan for the Future with Projections",
                subtitle:
                  "Analyze your financial trends to forecast future savings, expenses, and investments, ensuring better planning and preparedness.",
                btn_text: "Know your future projections",
                btn_link: "/dashboard",
              },
              {
                title: "Set and Achieve Financial Goals",
                subtitle:
                  "Create personalized savings goals, monitor your progress, and achieve your financial milestones with ease.",
                btn_text: "Set Goals",
                btn_link: "/dashboard",
              },
            ],
          },

          {
            groupOfThree: [
              {
                title: "Automated Expense Tracking",
                subtitle:
                  "Automatically categorize and track your daily expenses by linking your bank accounts and credit cards, giving you a real-time view of your spending habits.",
                btn_text: "Track Nows",
                btn_link: "/dashboard",
              },
              {
                title: "Debt Management to reduce cost",
                subtitle:
                  "Easily track and manage your debts, set repayment schedules, and visualize how to pay them off faster, helping you reduce financial stress.",
                btn_text: "Learn more",
                btn_link: "/dashboard",
              },
              {
                title: "Customizable Budgeting for future",
                subtitle:
                  "Create personalized budgets based on your income and financial goals, and track your progress with detailed reports and alerts. ",
                btn_text: "Known Budgeting",
                btn_link: "/dashboard",
              },
            ],
          },
        ],
        footer_section: {
          author_text: "Grodok.com",
          author_email: "mailto:hello@grodok.com",
          author_link: "/",
          privacy_link: "/",
          toc_link: "/",
        },
      }}
    />
  );
}
